import { lazyLoad } from '@utils/router'

/**
 * @description 此枚举用于标识路由所属模块，模块访问权限校验
 */
enum ModuleEnum {
  'HOME' = 'HOME', // 首页
  'COURSE' = 'COURSE', // 资源中心的路由
  'LIVE' = 'LIVE', // 直播的路由
  'VIDEO' = 'VIDEO', // 短视频的路由
  'EXAM' = 'EXAM', // 学考中心的路由
  'TRAIN' = 'TRAIN', // 培训中心的路由
  'INFO' = 'INFO', // 资讯中心的路由
  'KNOWLEDGE' = 'KNOWLEDGE', // 文库
  'PROFESSOR' = 'PROFESSOR', // 教官中心的路由
  'PERSONAL' = 'PERSONAL', // 个人中心的路由
  'PUBLICEXAM' = 'PUBLICEXAM', // 公开考试的路由
  'IKNOW' = 'IKNOW', // 知圈的路由
  'TRAININGPROJECT' = 'TRAININGPROJECT', // 培训项目
  'CLOUD_SCHOOL_TRAIN' = 'CLOUD_SCHOOL_TRAIN', // 云校我的培训项目,
  'QUALIFY_EXAM' = 'QUALIFY_EXAM', // 题库
}

/** 首页/home路由下的公共子路由 */
export default [
  {
    path: '/home/livelist/:activeTab?',
    component: lazyLoad(() => import('@views/WebLive/LiveList')),
    module: ModuleEnum.LIVE,
  },
  {
    path: '/home/liteVideo',
    component: lazyLoad(() => import('@views/LiteLive')),
    module: ModuleEnum.VIDEO,
  },
  {
    path: '/home/myCourse',
    component: lazyLoad(() => import('@views/MyCourse')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/myBoughtCourse',
    component: lazyLoad(() => import('@views/MyBoughtCourse')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/learnCard',
    component: lazyLoad(() => import('@views/LearnCardCourse')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/courseToptic/:id',
    component: lazyLoad(() => import('@views/CourseToptic')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/seminar/:id',
    component: lazyLoad(() => import('@views/Seminar')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/information/:id',
    component: lazyLoad(() => import('@views/Information')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/studyDetail/:id',
    component: lazyLoad(() => import('@views/StudyMap/StudyDetail')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/studyMapLearningReport/:id',
    component: lazyLoad(() => import('@views/StudyMap/learningReport')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/rankList/:id/:currentGate?',
    component: lazyLoad(() => import('@views/StudyMap/RankList')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/studyMapList/:currentTab?',
    component: lazyLoad(() => import('@views/StudyMap/MapList')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/studyMap/test/:name?/:id?',
    component: lazyLoad(() => import('@views/StudyMap/Testing')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/certificate/:id',
    component: lazyLoad(() => import('@views/StudyMap/Certificate')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/myTrainingClass',
    component: lazyLoad(() => import('@views/MyTrainingClass')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/trainingClass',
    component: lazyLoad(() => import('@views/TrainingClass')),
    module: ModuleEnum.TRAIN,
  },
  {
    path: '/home/myTrainingDetail/:classId',
    component: lazyLoad(() => import('@views/MyTrainingDetail')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/trainingClassDetail/:classId/:trainingItemId',
    component: lazyLoad(() => import('@views/TrainingClassDetail')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/agencyEnroll/:id/:name',
    component: lazyLoad(() => import('@views/AgencyEnroll')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/myWork',
    component: lazyLoad(() => import('@views/MyWork')),
    module: ModuleEnum.HOME,
  },
  {
    path:
      '/home/homework/:classId/:id/:score/:endTime?/:homeWorkSource?/:courseId?',
    component: lazyLoad(() =>
      import('@views/MyTrainingDetail/components/Homework')
    ),
    module: ModuleEnum.HOME,
  },
  {
    path:
      '/home/scoreDetail/:classId/:id/:score/:endTime?/:homeWorkSource?/:courseId?/:submitId?',
    component: lazyLoad(() =>
      import('@views/MyTrainingDetail/components/ScoreDetail/ScoreDetail')
    ),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/review/:classId/:classTitle',
    component: lazyLoad(() =>
      import('@views/MyTrainingDetail/components/Review')
    ),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/myTrainingLiveList/:classId',
    component: lazyLoad(() =>
      import('@views/MyTrainingDetail/components/LiveList')
    ),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/myTrainingCourseList/:classId',
    component: lazyLoad(() =>
      import('@views/MyTrainingDetail/components/CourseList')
    ),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/myTrainingExamList/:classId',
    component: lazyLoad(() =>
      import('@views/MyTrainingDetail/components/ExamList')
    ),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/myTrainingQuestionnaireList/:classId',
    component: lazyLoad(() =>
      import('@views/MyTrainingDetail/components/QuestionnaireList')
    ),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/courseDetail/:id/:trainingItemId?',
    component: lazyLoad(() => import('@views/CourseDetail')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/TrainingCourseDetail/:id/:trainingItemId?/:hasCloudSchool?',
    component: lazyLoad(() => import('@views/TrainingCourseDetail')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/myQuestionnaire',
    component: lazyLoad(() => import('@views/Questionnaire/List')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/myQuestionnaireDetail/:id',
    component: lazyLoad(() => import('@views/Questionnaire/Detail')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/publicExam',
    component: lazyLoad(() => import('@views/PublicExam')),
    module: ModuleEnum.PUBLICEXAM,
  },
  {
    path: '/home/PracticeTrain/list',
    component: lazyLoad(() => import('@views/PracticeTrain/List')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/PracticeTrain/studentDevelopPlan',
    component: lazyLoad(() =>
      import('@views/PracticeTrain/StudentDevelopPlan')
    ),
    module: ModuleEnum.KNOWLEDGE,
  },
  {
    path: '/home/practiceTrain/project',
    component: lazyLoad(() => import('@views/PracticeTrain/ProjectList')),
    module: ModuleEnum.KNOWLEDGE,
  },
  {
    path: '/home/practiceTrain/studentProject',
    component: lazyLoad(() =>
      import('@views/PracticeTrain/StudentProjectList')
    ),
    module: ModuleEnum.KNOWLEDGE,
  },
  {
    path: '/home/practiceTrain/dailyCanlendar',
    component: lazyLoad(() => import('@views/PracticeTrain/DailyCanlendar')),
    module: ModuleEnum.KNOWLEDGE,
  },
  {
    path: '/home/practiceTrain/weekReport',
    component: lazyLoad(() => import('@views/PracticeTrain/WeekReport')),
    module: ModuleEnum.KNOWLEDGE,
  },
  {
    path: '/home/practiceTrain/faceRecord',
    component: lazyLoad(() =>
      import('@views/PracticeTrain/components/FaceRecordList')
    ),
    module: ModuleEnum.KNOWLEDGE,
  },
  // 知圈
  {
    path: '/home/communicateCenter',
    component: lazyLoad(() => import('@views/CommunicateCenter')),
    module: ModuleEnum.IKNOW,
  },
  // 全部圈子
  {
    path: '/home/topic',
    component: lazyLoad(() => import('@views/Topic')),
    module: ModuleEnum.HOME,
  },
  // 发帖 可选路由参数
  {
    path: '/home/post/:id?',
    component: lazyLoad(() => import('@views/Post')),
    module: ModuleEnum.HOME,
  },
  // 圈子详情
  {
    path: '/home/topicDetail/:id',
    component: lazyLoad(() => import('@views/TopicDetail')),
    module: ModuleEnum.HOME,
  },
  // 帖子详情
  {
    path: '/home/postDetail/:id',
    component: lazyLoad(() => import('@views/PostDetail')),
    module: ModuleEnum.HOME,
  },
  // 个人中心 我的知圈
  {
    path: '/home/myTopic/:isLevel', // 1 竖版 2 横版
    component: lazyLoad(() => import('@views/MyTopic')),
    module: ModuleEnum.IKNOW,
  },
  // 圈主排行榜
  {
    path: '/home/topicManagerRange',
    component: lazyLoad(() => import('@views/TopicManagerRange')),
    module: ModuleEnum.HOME,
  },
  // 培训项目
  {
    path: '/home/humanTraining/:trainingItemId',
    component: lazyLoad(() => import('@views/HumanTraining')),
    module: ModuleEnum.HOME,
  },
  // 培训项目列表
  {
    path: '/home/trainingProjectList',
    component: lazyLoad(() => import('@views/HumanTraining/trainingProject')),
    module: ModuleEnum.HOME,
  },
  // 培训项目-目录-考试详情
  {
    path: '/home/trainingExamDetail/:examId/:trainingItemId',
    component: lazyLoad(() => import('@views/TrainingExamDetail')),
    module: ModuleEnum.HOME,
  },

  // 公开培训项目-列表-面包屑为：培训项目
  {
    path: '/home/openTrainingProjectList',
    component: lazyLoad(() => import('@views/OpenTrainProjects')),
    module: ModuleEnum.HOME,
  },
  // 公开培训项目-详情
  {
    path: '/home/openTrainingDetail',
    component: lazyLoad(() =>
      import('@views/OpenTrainProjects/constain/trainingDetail')
    ),
    module: ModuleEnum.HOME,
  },

  // 我的培训项目-列表
  {
    path: '/home/myTrainingProjectList',
    component: lazyLoad(() => import('@views/MyTrainingProject')),
    module: ModuleEnum.HOME,
  },

  // 培训报名-支付
  {
    path: '/home/openTrainingSign',
    component: lazyLoad(() => import('@views/SignTrain')),
    module: ModuleEnum.HOME,
  },

  // 培训报名-开票
  {
    path: '/home/billing',
    component: lazyLoad(() => import('@views/ApplyBill')),
    module: ModuleEnum.HOME,
  },
  {
    path: '/home/billingSuccess',
    component: lazyLoad(() => import('@views/ApplyBill/constain/success')),
  },

  // 我的订单
  {
    path: '/home/myOrder',
    component: lazyLoad(() => import('@views/MyOrder')),
    module: ModuleEnum.HOME,
  },
  // 我的订单-详情
  {
    path: '/home/myOrderDetail',
    component: lazyLoad(() => import('@views/MyOrder/contains/orderDetail')),
    module: ModuleEnum.HOME,
  },

  // 退款售后
  {
    path: '/home/refundSale',
    component: lazyLoad(() => import('@views/RefundSale')),
    module: ModuleEnum.HOME,
  },
  // 退款售后详情
  {
    path: '/home/refundSaleDetail',
    component: lazyLoad(() =>
      import('@views/RefundSale/constain/refundDetail')
    ),
    module: ModuleEnum.HOME,
  },
  // 试卷列表
  {
    path: '/home/examLibrary/List/:examId',
    component: lazyLoad(() => import('@views/ExamLibrary/ExamChapter')),
    module: ModuleEnum.HOME,
  },
  // 题库-考试详情
  {
    path: '/home/examLibraryDetail/:paperId',
    component: lazyLoad(() => import('@views/ExamLibrary/ExamDetail')),
    module: ModuleEnum.HOME,
  },
  // 题库-查看更多
  {
    path: '/home/examLibrary/examMore/:type/:subjectId',
    component: lazyLoad(() => import('@views/ExamLibrary/ExamFindMore')),
    module: ModuleEnum.HOME,
  },
  // 题库-去攻克
  {
    path: '/home/examLibrary/wrongList/:subjectId/:type',
    component: lazyLoad(() => import('@views/ExamLibrary/WrongList')),
    module: ModuleEnum.HOME,
  },
  // 题库
  {
    path: '/home/examLibrary/',
    component: lazyLoad(() => import('@views/ExamLibrary')),
    module: ModuleEnum.HOME,
  },
  // 主播-我的直播
  {
    path: '/home/myLive',
    component: lazyLoad(() => import('@views/WebLive/MyLive')),
    module: ModuleEnum.HOME,
  },
  // 岗位发展路径
  {
    path: '/home/jobDevelopPath',
    component: lazyLoad(() => import('@views/JobDevelopPath')),
    module: ModuleEnum.HOME,
  },
  // 岗位发展路径
  {
    path: '/home/studyReport/:postId/:postLevId',
    component: lazyLoad(() => import('@views/JobDevelopPath/studyReport')),
    module: ModuleEnum.HOME,
  },
]
